export const metaThemeColor = '#3f81ff'
